import { scrollMonitorServiceModule } from '../../services/scroll-monitor-service/scroll-monitor-service';
import { TABSET_EVT_SELECT } from '../tabs/tabs';

export const resizeToFillLeftoverComponentModule = angular
  .module('Q.components.resize-to-fill-leftover', [scrollMonitorServiceModule])

  /**
   * @ngdoc directive
   * @docType shared
   * @category directive
   * @name resizeToFillLeftover
   * @description
   * When provided a node selector, this will find the first node that matches, then resize the
   * element it's on to make sure that it is at least (viewport.height - otherNode.height) pixels high.
   *
   * @restrict A
   * @element ANY
   * @param {template} resizeToFillLeftover If provided, use this selector to detect the last item (otherwise use
   *                      the previous item in the parent node)
   * @param {template} resizeToFillLeftoverOffset If provided, reduce the adjusted height by this much
   */
  .directive(
    'resizeToFillLeftover',
    function (scrollMonitorService, $log, $document, $timeout) {
      return {
        restrict: 'A',
        link(scope, el, attrs) {
          let scrollWatcher = null;
          let nodeToTrack = null;
          let prev = null;

          attrs.$observe('resizeToFillLeftover', updateRefNode);

          scope.$on(TABSET_EVT_SELECT, _triggerUpdate);

          scope.$on('$destroy', () => {
            if (scrollWatcher) scrollWatcher.destroy();
          });

          function _triggerUpdate() {
            if (scrollWatcher) {
              $timeout(() => {
                scrollWatcher.listener.triggerUpdate(null, true);
              }, 100);
            }
          }

          function updateRefNode() {
            const node = attrs.resizeToFillLeftover;
            if (node !== '#' && (node || node === '')) {
              nodeToTrack = node;
              // async because the watched item might not be rendered yet
              scope.$applyAsync(() => {
                if (scrollWatcher) {
                  scrollWatcher.destroy();
                }
                try {
                  scrollWatcher = scrollMonitorService.addListener(
                    el.scrollableParent(),
                    onScroll,
                  );
                  _triggerUpdate();
                } catch (err) {
                  // we don't _really_ need to handle this
                  $log.debug(err);
                }
              });
            }
          }

          function onScroll(event, data) {
            const node = nodeToTrack
              ? $document[0].querySelector(nodeToTrack)
              : el[0].previousElementSibling;
            if (node) {
              let nodeHeight = angular.element(node).offsetHeight();
              let offset = +attrs.resizeToFillLeftoverOffset || 0;
              let height = data.viewportHeight - nodeHeight - offset;
              if (prev !== height) {
                el.css({ 'min-height': height + 'px' });
                prev = height;
              }
            }
          }
        },
      };
    },
  );
